import React, {Component} from 'react';
import {MDBCol, MDBRow, MDBListGroupItem, MDBIcon, MDBBadge} from 'mdbreact'
import {Link, withRouter} from "react-router-dom";
import firebase from "../../../Config/firebase";
import Jdenticon from 'react-jdenticon';
import classes from "../../PostList/PostList.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar, faStickyNote, faUserCircle, faUsers} from "@fortawesome/free-solid-svg-icons";
import {isAuth} from "../../../Utils/firebaseUtils";
import {connect} from "react-redux";
import ContentLoader from "react-content-loader";


const db = firebase.firestore()

class ListCommunity extends Component {
    typingTimer = null;

    constructor(props) {
        super(props);
        this.state = {
            communities: {},
            myCommunity: [],
            isLoadedCommunity: false,
            isLoading: false,
            searchQuery: ""
        }
    }

    componentDidMount() {
        this.getCommunityByID()
    }

    componentWillUnmount() {
        clearTimeout(this.typingTimer);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.auth !== nextProps.auth) {
            if (isAuth(nextProps.auth)) {
                this.getCustomClaim(nextProps.auth)
            }
        }
    }

    getCustomClaim = (auth) => {
        if (isAuth(auth)) {
            firebase.auth().currentUser.getIdTokenResult()
                .then(idTokenResult => {
                    if (idTokenResult.claims.hasOwnProperty("communityID") && Array.isArray(idTokenResult.claims.communityID)) {
                        this.getCommunity(idTokenResult.claims.hasOwnProperty('communityID') ? idTokenResult.claims.communityID : [])
                    } else {
                        this.setState({
                            myCommunity: []
                        }, () => {
                            this.setState({
                                isLoadedCommunity: true
                            })
                        })
                    }
                })
        }
    }

    getCommunity = (communityID) => {
        if (Array.isArray(communityID) && communityID.length !== 0) {
            let allPromise = []
            let allCommunity = []
            communityID.map(async (c, index) => {
                allPromise.push(
                    new Promise((resolve, reject) => {
                        db.collection('Community')
                            .doc(c)
                            .get()
                            .then(doc => {
                                if (doc.exists) {
                                    allCommunity.push({
                                        id: doc.id,
                                        ...doc.data()
                                    })
                                    resolve()
                                }
                            })
                            .catch(err => console.log(err))
                    })
                )
            })

            Promise.all(allPromise)
                .then(res => {
                    this.setState({
                        myCommunity: allCommunity
                    }, () => {
                        this.setState({
                            isLoadedCommunity: true
                        })
                    })
                })

        }
    }

    getCommunityByID = () => {
        db.collection('Community')
            .limit(8)
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allCommunity = []
                    docs.forEach(function (doc) {
                        const community = {
                            id: doc.id,
                            ...doc.data()
                        }
                        allCommunity.push(community)
                    })
                    this.setState({
                        communities: allCommunity
                    }, () => {
                        this.setState({
                            isLoaded: true
                        })
                    })

                }
            })
    }

    startToSearch = async (searchStr) => {
        return await new Promise((resolve, reject) => {
            fetch("/api/search/community", {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    searchStr: searchStr
                })
            }).then((res) => res.json()).then((searchResult) => {
                if (searchResult.length !== 0) {
                    searchResult.map((s, index) => {
                        searchResult[index].id = s.objectID
                    })
                    this.setState({
                        communities: searchResult
                    }, () => {
                        this.setState({
                            isLoading:false
                        })
                    })
                }
            })
        })
    }

    onInput = (e) => {
        this.setState({
            searchQuery: e.target.value,
            isLoading:true
        })
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
            if (this.state.searchQuery.length !== 0) {
                this.startToSearch(this.state.searchQuery)
            }
        }, 750);

    }

    render() {
        if (this.state.isLoaded) {
            return (
                <div>
                    <div className={classes.SearchInput}>
                        <input className={"form-control form-control-sm ml-3 w-75"} type="text" placeholder="Search"
                               aria-label="Search"
                               onChange={(e) => this.onInput(e)}
                        />
                    </div>
                    {/*<Link to={{*/}
                    {/*    pathname: '/community/common',*/}
                    {/*}}*/}
                    {/*      key={'link common'}*/}
                    {/*>*/}
                    {/*    <MDBListGroupItem className={classes.MyCommunityItem}>*/}
                    {/*        <FontAwesomeIcon icon={faStar} className={classes.MyCommunityStar}/>*/}
                    {/*        <MDBRow className={classes.PostInf}>*/}
                    {/*            <MDBCol size={2}>*/}
                    {/*                <div className={classes.ImageContainer}>*/}

                    {/*                    <Jdenticon size="28" value={"common"}/>*/}


                    {/*                </div>*/}
                    {/*            </MDBCol>*/}
                    {/*            <MDBCol size={10}>*/}

                    {/*                吹水台*/}

                    {/*            </MDBCol>*/}
                    {/*        </MDBRow>*/}
                    {/*    </MDBListGroupItem>*/}
                    {/*</Link>*/}
                    {/*<Link to={{*/}
                    {/*    pathname: '/community/debug',*/}
                    {/*}}*/}
                    {/*      key={'link Tmingler debug'}*/}
                    {/*>*/}
                    {/*    <MDBListGroupItem className={classes.MyCommunityItem}>*/}
                    {/*        <FontAwesomeIcon icon={faStar} className={classes.MyCommunityStar}/>*/}
                    {/*        <MDBRow className={classes.PostInf}>*/}
                    {/*            <MDBCol size={2}>*/}
                    {/*                <div className={classes.ImageContainer}>*/}

                    {/*                    <Jdenticon size="28" value={"debug"}/>*/}


                    {/*                </div>*/}
                    {/*            </MDBCol>*/}
                    {/*            <MDBCol size={10}>*/}

                    {/*                功能改善意見*/}

                    {/*            </MDBCol>*/}
                    {/*        </MDBRow>*/}
                    {/*    </MDBListGroupItem>*/}
                    {/*</Link>*/}
                    {
                        this.state.isLoadedCommunity ?
                            this.state.myCommunity.map(community => {
                                return (
                                    <Link to={{
                                        pathname: '/community/' + community.id,
                                        state: {
                                            community: community
                                        }
                                    }}
                                          key={'link' + community.id}
                                    >
                                        <MDBListGroupItem className={classes.MyCommunityItem}>
                                            <FontAwesomeIcon icon={faStar} className={classes.MyCommunityStar}/>
                                            <MDBRow className={classes.PostInf}>
                                                <MDBCol size={2}>
                                                    <div className={classes.ImageContainer}>
                                                        {
                                                            typeof community.avatar !== 'undefined' && community.avatar !== '' ?
                                                                <img className={classes.Avatar} src={community.avatar}
                                                                     alt={community.titleCHI}/>
                                                                :
                                                                <Jdenticon size="28" value={community.id}/>
                                                        }

                                                    </div>
                                                </MDBCol>
                                                <MDBCol size={10}>

                                                    {community.titleCHI}

                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBBadge color="light" className={classes.MyItemLogoContainer}>
                                                    <FontAwesomeIcon icon={faUsers} className={classes.MyItemLogo}/>
                                                    <span>
                                                    #2
                                                </span>
                                                </MDBBadge>
                                            </MDBRow>
                                        </MDBListGroupItem>
                                    </Link>
                                )
                            })
                            : ''
                    }
                    <div className={classes.AllCommunityList}>
                        {
                            !this.state.isLoading ?
                            this.state.communities.map((community, index) => {
                                return (
                                    <Link to={{
                                        pathname: '/community/' + community.id,
                                        state: {
                                            community: community
                                        }
                                    }}
                                          key={'link' + community.id}
                                    >
                                        <MDBListGroupItem className={classes.CommunityItem}>
                                            <MDBRow className={classes.PostInf}>
                                                <MDBCol size={2}>
                                                    <div className={classes.ImageContainer}>
                                                        {
                                                            typeof community.avatar !== 'undefined' && community.avatar !== '' ?
                                                                <img className={classes.Avatar} src={community.avatar}
                                                                     alt={community.titleCHI}/>
                                                                :
                                                                <Jdenticon size="28" value={community.id}/>
                                                        }

                                                    </div>
                                                </MDBCol>
                                                <MDBCol size={10}>

                                                    {community.titleCHI}

                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBBadge color="light" className={classes.ItemLogoContainer}>
                                                    <FontAwesomeIcon icon={faUsers} className={classes.ItemLogo}/>
                                                    <span>
                                                    #2
                                                </span>
                                                </MDBBadge>

                                            </MDBRow>
                                        </MDBListGroupItem>
                                    </Link>
                                )
                            })
                                :
                                <ContentLoader
                                    speed={2}
                                    width={255}
                                    height={600}
                                    viewBox="0 0 255 600"
                                    backgroundColor="#e8e8e8"
                                    foregroundColor="#ffffff"
                                    animate="false"
                                >
                                    <rect x="5" y="5" rx="5" ry="5" width="255" height="90"/>
                                    <rect x="5" y="105" rx="5" ry="5" width="255" height="90"/>
                                </ContentLoader>
                        }
                    </div>


                </div>
            )
        } else {
            return (
                <div>
                    Loading
                </div>
            )
        }

    }
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(ListCommunity))